import {
  PriceIdEnum as PriceIdEnumArray,
  ProductKindEnum,
} from '@iheartjane/types';
import { z } from 'zod';

export const NavigationCategoryEnum = z.enum([
  ...ProductKindEnum,
  'best-selling',
  'deals',
  'featured',
  'shop-all',
  'jane-gold',
]);
export type NavigationCategory = z.infer<typeof NavigationCategoryEnum>;

export const PriceIdEnum = z.enum(PriceIdEnumArray);
